import React, { useEffect, useState } from "react";
import SwoodleUpdatedLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import PrimaryButton from "../../common/PrimaryButton";
import TextInput from "../../common/SignUp/TextInput";
import person from "../../../Assets/Images/Person.svg";
import passwordIcon from "../../../Assets/Icons/passwordIcon.svg";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { createMerchantAccountSchema } from "../../../utils/validationSchemas";
import { useNavigate, useParams } from "react-router-dom";
import { merchantOnboard } from "../../../services/onboardingService";
import Loader from "../../common/Loader";

const CreateAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);
  const { verificationCode } = useParams();
  const loading = useSelector((state) => state?.onboardingReducer?.loading);
  const merchantEmail = useSelector(
    (state) => state?.onboardingReducer?.merchantInviteSent?.email
  );


  // Only check presence of verificationCode and redirect if missing
  useEffect(() => {
    if (!verificationCode) {
      navigate("/");
    }
  }, [verificationCode, navigate]);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: createMerchantAccountSchema,
    onSubmit: async (values) => {
      try {
        const merchantPromise = await dispatch(
          merchantOnboard({
            name: values?.firstName + " " + values?.lastName,
            password: values?.password,
            code: verificationCode,
          })
        ).unwrap();
        if (merchantPromise?.success === true) {
          // Fire GTM event for merchant onboarding success
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "merchant_form_completed",
            formType: "Merchant",
          });
          navigate("/account-created");
        }
      } catch (error) {
        console.error("Error during merchant onboarding:", error);
      }
    },
  });

  const { firstName, lastName, password, confirmPassword } = formik.values;

  const {
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    // setFieldValue,
  } = formik;

  const scrollToFirstError = (formErrors) => {
    const priority = [
      'firstName',
      'lastName',
      'password',
      'confirmPassword'
    ];
    let targetField = priority.find((key) => formErrors && Object.prototype.hasOwnProperty.call(formErrors, key));
    if (!targetField) {
      const keys = Object.keys(formErrors || {});
      targetField = keys.length ? keys[0] : null;
    }
    if (!targetField) return;
    const el = document.querySelector(`[data-field="${targetField}"]`) || document.querySelector(`[name="${targetField}"]`);
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof el.focus === 'function') {
        try { el.focus(); } catch (_) { }
      }
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await formik.validateForm();
    if (Object.keys(validationErrors || {}).length > 0) {
      formik.setTouched(Object.keys(validationErrors).reduce((acc, k) => { acc[k] = true; return acc; }, {}), true);
      scrollToFirstError(validationErrors);
      return;
    }
    handleSubmit(e);
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setConfirmShowPassword(!showConfirmPassword);
  };



  return (
    <form
      className="w-full py-10 h-screen flex flex-col items-center offerform"
      onSubmit={handleFormSubmit}
    >
      {loading && <Loader />}
      <>
        <p className="font-poppins font-[500] text-[14px] sm:text-[18px] md:text-[22px] lg:text-[26px] text-[#303030] px-4">
          Welcome to Swoodle! Let's set up your Account!
        </p>
        <div className="flex flex-col items-center w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] xl:w-[45%] 2xl:w-[40%]">
          <img src={SwoodleUpdatedLogo} alt="Swoodle" className="pt-[6%] pb-[2%] w-[60%]"></img>
          <p className="font-poppins font-[500] sm:text-[18px] md:text-[22px] lg:text-[26px] text-[#303030]">
            MERCHANT
          </p>
          <div className="flex flex-col justify-start items-start gap-2 w-full">
            <p className="font-poppins font-[500] text-[14px] sm:text-[16px] md:text-[18px] lg:text-[18px] xl:text-[22px] text-[#303030] mt-6 sm:mt-10 mb-3 text-start">
              Create Your Account
            </p>
            {/* <p className="font-poppins font-[400] text-[12px] sm:text-[16px] md:text-[18px] lg:text-[18px] xl:text-[22px] text-[#767676] mt-2 mb-4 text-start">
            Email: {merchantEmail || "Email will be set from verification code"}
          </p> */}
            <TextInput
              Icon={person}
              name={"firstName"}
              value={firstName}
              placeholder={"First Name"}
              inputClass={
                "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
              }
              iconAreaClass={
                "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
              }
              innerDivClass={"h-[45px] sm:h-[55px]"}
              inputDivClass={"h-[70px] sm:h-[75px]"}
              handleChange={handleChange}
              handleBlur={handleBlur}
              error={errors.firstName}
              touched={touched.firstName}
            />
            <TextInput
              Icon={person}
              name={"lastName"}
              value={lastName}
              placeholder={"Last Name"}
              inputClass={
                "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
              }
              iconAreaClass={
                "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
              }
              innerDivClass={"h-[45px] sm:h-[55px]"}
              inputDivClass={"h-[70px] sm:h-[75px]"}
              handleChange={handleChange}
              handleBlur={handleBlur}
              error={errors.lastName}
              touched={touched.lastName}
            />

            <TextInput
              Icon={passwordIcon}
              type={showPassword ? "text" : "password"}
              name={"password"}
              value={password}
              placeholder={"Password"}
              inputClass={
                "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
              }
              iconAreaClass={
                "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
              }
              innerDivClass={"h-[45px] sm:h-[55px]"}
              inputDivClass={"h-[70px] sm:h-[75px]"}
              handleChange={handleChange}
              handleBlur={handleBlur}
              error={errors.password}
              touched={touched.password}
              showPassword={showPassword}
              togglePassword={togglePassword}
              autoComplete={"new-password"}
            />
            <TextInput
              Icon={passwordIcon}
              type={showConfirmPassword ? "text" : "password"}
              name={"confirmPassword"}
              value={confirmPassword}
              placeholder={"Confirm Password"}
              inputClass={
                "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
              }
              iconAreaClass={
                "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
              }
              innerDivClass={"h-[45px] sm:h-[55px]"}
              inputDivClass={"h-[70px] sm:h-[75px]"}
              handleChange={handleChange}
              handleBlur={handleBlur}
              error={errors.confirmPassword}
              touched={touched.confirmPassword}
              showPassword={showConfirmPassword}
              togglePassword={toggleConfirmPassword}
            />
            <p className="text-[11px] sm:text-[12px] md:text-[14px] font-poppins font-[400] mt-2 text-start w-[95%] leading-tight">
              By clicking 'Create Account', I agree to the
              <span
                className="text-[#00ADEF] font-[500] cursor-pointer"
                onClick={() => window.open("/privacy/toc", "_blank")}
              >
                {" "}
                Terms of Use{" "}
              </span>
              that I have read the
              <span
                className="text-[#00ADEF] font-[500] cursor-pointer"
                onClick={() => window.open("/privacy/policy", "_blank")}
              >
                {" "}
                Privacy Policy.
              </span>
            </p>
          </div>
          <div className="text-center w-full">
            <PrimaryButton
              type={"submit"}
              className={
                "w-[85%] sm:w-[50%] md:w-[40%] lg:w-[50%] font-poppins text-[12px] sm:text-[14px] lg:text-[16px] text-center font-[500] h-[40px] sm:h-[45px] md:h-[50px] lg:h-[55px] rounded-[10px] my-6 sm:my-10 tracking-wide"
              }
              label="Create Account"
            />
          </div>
        </div>
      </>
    </form>
  );
};

export default CreateAccount;
